import { useState, useEffect, useCallback } from 'react';
import { playbookApi } from '../api/playbookApi';
import type { PlaybookStatus, AvailableTransition } from '../types/playbook.types';

export function usePlaybookTransitions(instanceId: string | null) {
  const [currentStatus, setCurrentStatus] = useState<PlaybookStatus | null>(null);
  const [transitions, setTransitions] = useState<AvailableTransition[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!instanceId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await playbookApi.getAvailableTransitions(instanceId);
      const data = res as any;
      setCurrentStatus(data.currentStatus);
      setTransitions(data.transitions || []);
    } catch (err) {
      console.error('[usePlaybookTransitions] Failed to load transitions:', err);
      setError(err instanceof Error ? err.message : 'Failed to load transitions');
    } finally {
      setLoading(false);
    }
  }, [instanceId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { currentStatus, transitions, loading, error, refresh };
}
